export default {
  selectVerifyEmailStatus: (state) => state.emailVerification.verifyEmailStatus,
  selectVerifyStripeError: (state) => state.emailVerification.verifyStripeError,
};
